import { ToastContext } from 'common/components/toasts/ToastContext';
import { useContext } from 'react';

export const useToast = () => useContext(ToastContext);
